import React from "react";
import { createSlice } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/src-refactor/modules/store/store";

const initialState = {
  buildingOpen: null
};

const buildingToolsSlice = createSlice({
  name: "buildingTools",
  initialState,
  reducers: {
    setBuildingOpen: (state, action) => {
      state.buildingOpen = action.payload;
    },
    resetBuildingToolsState: () => initialState // Add reset reducer
  }
});

export const { setBuildingOpen, resetBuildingToolsState } =
  buildingToolsSlice.actions; // Export the reset action

export const useBuildingOpen = () => {
  const dispatch = useDispatch();

  const buildingOpen = useSelector(
    (state: RootState) => state.buildingTools.buildingOpen
  );

  const onSetBuildingOpen = (value: number | null) => {
    dispatch(setBuildingOpen(value));
  };

  return {
    onSetBuildingOpen,
    buildingOpen
  };
};

export const useResetBuildingToolsState = () => {
  const dispatch = useDispatch();
  return () => dispatch(resetBuildingToolsState());
};

export default buildingToolsSlice;
